module.exports = __webpack_public_path__ + "static/media/groceries-on-hover.dd83e3f2.png";